<!--  -->
<template>
  <div class="ContactOur">
    <div class="Contact_main">
      <div class="Contact_help">
        <h1>{{ How_help }}</h1>

        <div class="Contact_box">
          <h2>{{ Give_Us }}</h2>
          <h1>{{ Telephone }}</h1>
          <p>{{ Telephonenumb }}</p>
        </div>
        <div class="Contact_box">
          <h2>{{ Send_Us }}</h2>
          <h1>{{ Emailtext }}</h1>
          <p>{{ EmailUs }}</p>
        </div>
        <div class="Contact_box">
          <h2>{{ Welcome }}</h2>
          <h1>{{ Sitetext }}</h1>
          <p>{{ Site }}</p>
        </div>
      </div>

      <div class="Contact_form">
        <h1>{{ Contact_us }}</h1>

        <div class="name_box">
          <input
            type="text"
            class="name"
            v-model="name"
            :placeholder="Nametishi"
          />
          <span>{{ name_tishishuru }}</span>
        </div>

        <div class="email_box">
          <input
            type="text"
            class="email"
            v-model="email"
            :placeholder="Emailtishi"
          />
          <span>{{ email_tishishuru }}</span>
        </div>

        <div class="phone_box">
          <input
            type="text"
            class="phone"
            v-model="phone"
            :placeholder="Phonetishi"
          />
          <span>{{ phone_tishishuru }}</span>
        </div>

        <div class="advice_box">
          <textarea
            class="advice"
            v-model="advice"
            :placeholder="Advicetishi"
          ></textarea>
          <span>{{ advice_tishishuru }}</span>
        </div>

        <div class="sumbit" @click="onSumbit">
          <span>{{ Send }}</span>
          <p>{{ succeed }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      How_help: "",

      Give_Us: "",
      Telephone: "",
      Telephonenumb: "",

      Send_Us: "",
      Emailtext: "",
      EmailUs: "",

      Welcome: "",
      Sitetext: "",
      Site: "",

      Contact_us: "",

      Nametishi: "",
      Emailtishi: "",
      Phonetishi: "",
      Advicetishi: "",

      Send: "",

      // Please fill in the contents
      name_tishishuru: "",
      email_tishishuru: "",
      phone_tishishuru: "",
      advice_tishishuru: "",

      succeed: "",

      name: "",
      email: "",
      phone: "",
      advice: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      this.$alert("<strong>Thanks for your inquiry</strong>", "Message", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "OK",
      });
    },
    onSumbit() {
      if (
        this.name != "" &&
        this.email != "" &&
        this.phone != "" &&
        this.advice != ""
      ) {
        var that = this;
        //  在这里发送提交
        $.ajax({
          url: "/index.php?s=Home/Api/get_data",
          type: "post",
          datatype: "json",
          data: {
            act: "contactus",
            username: that.name,
            email: that.email,
            mobile: that.phone,
            content: that.advice,
          },
          beforeSend: function () {
            that.succeed = "loding.....";
          },
          success: function (ret) {
            var obj = JSON.parse(ret); //json数据转为数组
            if (obj.code == "0000") {
              that.name_tishishuru = "";
              that.email_tishishuru = "";
              that.phone_tishishuru = "";
              that.advice_tishishuru = "";
              that.name = "";
              that.email = "";
              that.phone = "";
              that.advice = "";
              that.succeed = "Thanks for your inquiry";
              that.$router.push({ path: "/Thanks" });
              // setInterval(function () {
              //   that.succeed = "";
              // }, 5000);
            } else {
              that.succeed = "Submission failed";
            }
          },
          error: function (err) {
            console.log("ajax错误");
          },
        });
      } else {
        if (this.name == "") {
          this.name_tishishuru = "Please fill in the contents";
        } else {
          this.name_tishishuru = "";
        }
        if (this.email == "") {
          this.email_tishishuru = "Please fill in the contents";
        } else {
          var yx_yz =
            /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
          if (!yx_yz.test(this.email)) {
            this.email_tishishuru =
              "Please fill in the correct email information";
          } else {
            this.email_tishishuru = "";
          }
        }
        if (this.phone == "") {
          this.phone_tishishuru = "Please fill in the contents";
        } else {
          this.phone_tishishuru = "";
        }
        if (this.advice == "") {
          this.advice_tishishuru = "Please fill in the contents";
        } else {
          this.advice_tishishuru = "";
        }
      }
    },

    get_fanyi() {
      var that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            console.log(obj);
            that.How_help = obj.data.zmbn;

            that.Give_Us = obj.data.gwmddh;
            that.Telephone = obj.data.dh;

            that.Send_Us = obj.data.gwmfyj;
            that.Emailtext = obj.data.yx;

            that.Welcome = obj.data.hylf;
            that.Sitetext = obj.data.wz;

            that.Contact_us = obj.data.lxwm;

            that.Nametishi = obj.data.xm;
            that.Emailtishi = obj.data.yx;
            that.Phonetishi = obj.data.dh;
            that.Advicetishi = obj.data.jy;
            that.Send = obj.data.tj;
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    get_config() {
      var that = this;
      // 获取界面配置项
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_config",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            if (obj.lang) {
              that.Site = obj.data[11].value;
              that.EmailUs = obj.data[6].value;
              that.Telephonenumb = obj.data[13].value;
            } else {
              that.Site = obj.data[5].value;
              that.EmailUs = obj.data[6].value;
              that.Telephonenumb = obj.data[12].value;
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.$route.query.emai);
    if (this.$route.query.email == undefined) {
      this.email = "";
    } else {
      this.email = this.$route.query.email;
    }
    this.get_fanyi();
    this.get_config();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.ContactOur {
  width: 100%;
  padding: 110px 9.25rem;
  .Contact_main {
    display: flex;
    justify-content: space-between;
    .Contact_help {
      width: 35%;
      h1 {
        font-size: 1rem;
        font-weight: 400;
        color: #39404a;
      }
      .Contact_box {
        margin-top: 100px;
        border-left: 3px solid #66d289;
        h2 {
          margin-left: 36px;
          margin-top: 10px;
          font-size: 1rem;
          font-weight: 400;
          color: #969696;
        }
        h1 {
          margin-left: 36px;
          margin-top: 22px;
          font-size: 1.8rem;
          font-weight: 400;
          color: #39404a;
        }
        p {
          margin-left: 36px;
          margin-top: 22px;
          margin-bottom: 10px;
          font-size: 1.2rem;
          font-weight: 400;
          color: #39404a;
        }
      }
      .Contact_box:nth-of-type(1) {
        margin-top: 50px;
      }
    }

    .Contact_form {
      width: 55%;
      h1 {
        font-size: 1rem;
        font-weight: 400;
        color: #39404a;
      }
      input {
        background: #f2f2f2;
        padding: 28px 24px;
        font-size: 1rem;
        font-weight: 400;
        color: #969696;
        border-radius: 10px;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        font-size: 1rem;
        font-weight: 400;
        color: #969696;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        font-size: 1rem;
        font-weight: 400;
        color: #969696;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        font-size: 1rem;
        font-weight: 400;
        color: #969696;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        font-size: 1rem;
        font-weight: 400;
        color: #969696;
      }
      .name_box {
        display: inline-block;
        width: 45%;
        position: relative;
        .name {
          width: 100%;
          margin-top: 70px;
        }
        span {
          position: absolute;
          display: block;
          bottom: -20px;
          left: 20px;
          font-size: 0.7rem;
          color: #e60012;
        }
      }

      .email_box {
        display: inline-block;
        width: 45%;
        position: relative;
        .email {
          margin-top: 70px;
          width: 100%;
          margin-left: 40px;
        }
        span {
          position: absolute;
          display: block;
          bottom: -20px;
          left: 60px;
          font-size: 0.7rem;
          color: #e60012;
        }
      }

      .phone_box {
        display: inline-block;
        width: 90%;
        position: relative;
        .phone {
          margin-top: 40px;
          width: 100%;
        }
        span {
          position: absolute;
          display: block;
          bottom: -20px;
          left: 20px;
          font-size: 0.7rem;
          color: #e60012;
        }
      }

      .advice_box {
        display: inline-block;
        width: 90%;
        position: relative;
        .advice {
          margin-top: 40px;
          width: 100%;
          height: 238px;
          border: none;
          border-radius: 10px;
          background: #f2f2f2;
          font-family: Arial;
          padding: 28px 0 0 24px;
          font-size: 1rem;
          font-weight: 400;
          color: #969696;
          outline: none;
        }
        span {
          position: absolute;
          display: block;
          bottom: -20px;
          left: 20px;
          font-size: 0.7rem;
          color: #e60012;
        }
      }

      .sumbit {
        cursor: pointer;
        margin-top: 50px;
        width: 204px;
        height: 60px;
        background: #5fbb68;
        position: relative;
        span {
          display: inline-block;
          width: 100%;
          text-align: center;
          font-size: 1.2rem;
          font-weight: 900;
          color: #ffffff;
          line-height: 60px;
        }
        p {
          position: absolute;
          bottom: -20px;
          font-size: 0.7rem;
          color: #5fbb68;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .ContactOur {
    padding: 40px 10px;
    .Contact_main {
      flex-direction: column;
      .Contact_help {
        width: 100%;
      }
      .Contact_form {
        width: 100%;
        margin-top: 40px;
        .name_box {
          display: block;
          width: 100%;
          .name {
            margin-top: 20px;
          }
        }
        .phone_box {
          display: block;
          width: 100%;
        }
        .advice_box {
          display: block;
          width: 100%;
        }
        .email_box {
          display: block;
          width: 100%;
          .email {
            margin-left: 0;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contact/ContactOur.vue